define.alias("shared/components/shared/ui/social-set-switcher/list", "media/components/shared/ui/social-set-switcher/list");